module.exports = __webpack_public_path__ + "static/media/icons-menu_40.af2153cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons-menu_40.png
// module id = 462
// module chunks = 0